// Module
var code = "<check-lookup-widget></check-lookup-widget> ";
// Exports
module.exports = code;